import {Turbo} from '@hotwired/turbo-rails'

// When a same-page refresh (a Turbo visit to the current URL) fails at the network level, Turbo
// falls back to a full page load, which on a dead link replaces the results with the browser's
// error page. Keep the last good page instead; the connection banner reports the outage and the
// next refresh retries. Navigation to other pages keeps Turbo's default behaviour.
export default function keepPageOnFailedRefresh() {
  document.addEventListener('turbo:fetch-request-error', (event) => {
    if (event.detail.request.url.href != window.location.href) return

    event.preventDefault()
    Turbo.navigator.stop()
  })
}
